import { render, staticRenderFns } from "./ONVO.vue?vue&type=template&id=420a8d84&scoped=true"
import script from "./ONVO.vue?vue&type=script&lang=js"
export * from "./ONVO.vue?vue&type=script&lang=js"
import style0 from "./ONVO.vue?vue&type=style&index=0&id=420a8d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a8d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
